import React from "react";

const CopyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      viewBox="0 0 27 27"
    >
      <path
        d="M-1 3.7044L-1 1.875Q-1 1.29075 -0.773665 0.755622Q-0.555368 0.239499 -0.157947 -0.157927Q0.239478 -0.555357 0.755602 -0.773658Q1.29074 -1 1.875 -1L18.125 -1Q18.7093 -1 19.2444 -0.773658Q19.7605 -0.555355 20.1579 -0.157927Q20.5554 0.239495 20.7737 0.755621Q21 1.29075 21 1.875L21 18.125Q21 18.7093 20.7737 19.2444Q20.5554 19.7605 20.1579 20.1579Q19.7605 20.5554 19.2444 20.7737Q18.7093 21 18.125 21L16.2609 21L16.2609 19L18.125 19Q18.4875 19 18.7437 18.7437Q19 18.4875 19 18.125L19 1.875Q19 1.51256 18.7437 1.25628Q18.4874 1 18.125 1L1.875 1Q1.51255 1 1.25627 1.25628Q1 1.51256 1 1.875L1 3.7044L-1 3.7044Z"
        fillRule="nonzero"
        transform="matrix(1 0 0 1 6 1)"
        fill="rgb(255, 255, 255)"
      />
      <rect
        width="21.25"
        height="21.25"
        rx="1.5"
        ry="1.5"
        strokeWidth="2"
        strokeLinejoin="round"
        transform="matrix(1 0 0 1 1 4.75)"
        stroke="rgb(255, 255, 255)"
        fill="transparent"
      />
      <path
        d="M2.58665 -0.0251434L-0.721166 3.41829C-1.10376 3.81658 -1.09105 4.44962 -0.692762 4.83222C-0.294476 5.21482 0.338568 5.2021 0.721166 4.80382L4.02898 1.36038Q4.39691 0.992706 4.95025 1.00012Q5.51929 1.00775 5.93089 1.41935Q6.34249 1.83095 6.35012 2.4Q6.35754 2.95333 5.97554 3.3353Q5.9654 3.34544 5.95555 3.35587L4.76174 4.62012C4.38257 5.02167 4.4007 5.65458 4.80225 6.03375C5.2038 6.41293 5.83671 6.39479 6.21588 5.99324L7.40071 4.73851Q7.87377 4.26115 8.11978 3.63719Q8.35876 3.03106 8.34994 2.37319Q8.34118 1.71926 8.08881 1.11356Q7.8283 0.488329 7.34511 0.00513774Q6.86192 -0.478054 6.23669 -0.73856Q5.63098 -0.990932 4.97705 -0.999698Q4.31918 -1.00852 3.71306 -0.769539Q3.08186 -0.520679 2.58665 -0.0251434Z"
        fillRule="evenodd"
        transform="matrix(1 0 0 1 10.0247 8.83259)"
        fill="rgb(255, 255, 255)"
      />
      <path
        d="M2.37529 -0.707107C1.98477 -1.09763 1.3516 -1.09763 0.96108 -0.707107Q0.649321 -0.395348 -0.0049108 0.236475L-0.00491431 0.236479Q-0.498982 0.730299 -0.754896 1.38208Q-0.996696 1.9979 -0.999957 2.66986Q-1.00324 3.34653 -0.763925 3.96657Q-0.508667 4.62792 -0.0173571 5.11923Q0.465836 5.60242 1.09106 5.86292Q1.69676 6.11529 2.35069 6.12404Q3.00853 6.13285 3.61466 5.89389Q4.23366 5.64984 4.70843 5.18233L7.91974 2.26689C8.32864 1.89566 8.35918 1.26323 7.98795 0.854324C7.61672 0.445421 6.98429 0.414879 6.57539 0.786109L3.34776 3.71636Q3.32991 3.73257 3.31285 3.74962Q2.93081 4.13163 2.37747 4.12422Q1.80844 4.1166 1.39686 3.70502Q0.996983 3.30514 1.00002 2.67956Q1.00304 2.05671 1.38441 1.67515L1.38445 1.67512Q2.05121 1.03119 2.37529 0.707107C2.76581 0.316586 2.76581 -0.316586 2.37529 -0.707107Z"
        fillRule="evenodd"
        transform="matrix(1 0 0 1 5.24805 16.4669)"
        fill="rgb(255, 255, 255)"
      />
      <path
        d="M1.37475 -0.707062C0.984258 -1.09761 0.351086 -1.09765 -0.0394596 -0.707152Q-0.554882 -0.191795 -0.802369 0.492045Q-1.03987 1.14829 -0.992311 1.8516Q-0.951318 2.45829 -0.701548 3.01442Q-0.443747 3.58843 0.00512028 4.03729C0.395641 4.42782 1.02881 4.42782 1.41933 4.03729C1.80985 3.64677 1.80985 3.0136 1.41933 2.62308Q1.03865 2.2424 1.00314 1.71677Q0.96272 1.11904 1.37466 0.707152C1.76521 0.316656 1.76525 -0.316516 1.37475 -0.707062Z"
        fillRule="evenodd"
        transform="matrix(1 0 0 1 9.4519 12.875)"
        fill="rgb(255, 255, 255)"
      />
      <path
        d="M-0.707107 0.707107C-1.09763 0.316586 -1.09763 -0.316586 -0.707107 -0.707107C-0.316586 -1.09763 0.316586 -1.09763 0.707107 -0.707107Q1.1903 -0.223915 1.4508 0.401313Q1.70318 1.00702 1.71194 1.66095Q1.72076 2.31882 1.48178 2.92494Q1.23292 3.55614 0.751707 4.03732C0.361172 4.42783 -0.271999 4.4278 -0.662507 4.03727C-1.05301 3.64674 -1.05299 3.01356 -0.662457 2.62306Q-0.280462 2.24109 -0.287879 1.68775Q-0.295506 1.11871 -0.707107 0.707107Z"
        fillRule="evenodd"
        transform="matrix(1 0 0 1 12.4509 14.6632)"
        fill="rgb(255, 255, 255)"
      />
    </svg>

    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="60"
    //   height="60"
    //   viewBox="0 0 60 60"
    // >
    //   <defs>
    //     <clipPath id="clipPath3843864354">
    //       <path
    //         d="M0 0L39 0L39 39L0 39L0 0Z"
    //         fillRule="nonzero"
    //         transform="matrix(1 0 0 1 0 0)"
    //       />
    //     </clipPath>
    //   </defs>
    //   <g
    //     transform="translate(10.5, 10.5) scale(1)"
    //     clipPath="url(#clipPath3843864354)"
    //   >
    //     <path
    //       d="M-1 4.81572L-1 2.4375Q-1 1.73881 -0.729462 1.09917Q-0.46847 0.482104 0.00680226 0.00682592Q0.482079 -0.468456 1.09915 -0.729454Q1.73879 -1 2.4375 -1L23.5625 -1Q24.2612 -1 24.9009 -0.729454Q25.5179 -0.468455 25.9932 0.00682575Q26.4685 0.4821 26.7295 1.09917Q27 1.73881 27 2.4375L27 23.5625Q27 24.2612 26.7295 24.9008Q26.4685 25.5179 25.9932 25.9932Q25.5179 26.4685 24.9008 26.7295Q24.2612 27 23.5625 27L21.1391 27L21.1391 25L23.5625 25Q24.158 25 24.579 24.579Q25 24.158 25 23.5625L25 2.4375Q25 1.84206 24.579 1.42103Q24.1579 1 23.5625 1L2.4375 1Q1.84205 1 1.42102 1.42103Q1 1.84206 1 2.4375L1 4.81572L-1 4.81572Z"
    //       fillRule="nonzero"
    //       transform="matrix(1 0 0 1 9.75 3.25)"
    //       fill="rgb(255, 255, 255)"
    //     />
    //     <rect
    //       width="27.625"
    //       height="27.625"
    //       rx="1.5"
    //       ry="1.5"
    //       strokeWidth="2"
    //       strokeLinejoin="round"
    //       transform="matrix(1 0 0 1 3.25 8.125)"
    //       stroke="rgb(255, 255, 255)"
    //       fill="transparent"
    //     />
    //     <path
    //       d="M3.57899 0.175142L-0.721166 4.65161C-1.10376 5.0499 -1.09105 5.68294 -0.692762 6.06554C-0.294476 6.44814 0.338568 6.43542 0.721166 6.03714L5.02132 1.56067Q5.59339 0.988847 6.43934 1.00019Q7.30101 1.01174 7.92229 1.63302Q8.54358 2.25431 8.55513 3.11598Q8.56647 3.96193 7.98033 4.54803Q7.97019 4.55817 7.96034 4.5686L6.40839 6.21212C6.02921 6.61367 6.04735 7.24658 6.4489 7.62576C6.85044 8.00493 7.48335 7.98679 7.86253 7.58525L9.40532 5.95143Q9.97878 5.37373 10.2766 4.61831Q10.5656 3.88531 10.555 3.08917Q10.5443 2.29697 10.2385 1.56301Q9.92269 0.804994 9.33651 0.218811Q8.75032 -0.367372 7.99231 -0.683204Q7.25835 -0.989015 6.46615 -0.999634Q5.67 -1.01031 4.93701 -0.721309Q4.17447 -0.420663 3.57899 0.175142Z"
    //       fillRule="evenodd"
    //       transform="matrix(1 0 0 1 14.9821 13.4324)"
    //       fill="rgb(255, 255, 255)"
    //     />
    //     <path
    //       d="M1.46154 -0.707107C1.85206 -1.09763 2.48523 -1.09763 2.87575 -0.707107C3.26627 -0.316586 3.26627 0.316586 2.87575 0.707107Q2.45494 1.12792 1.59134 1.96189L1.59134 1.96189Q1.31687 2.23656 1.15952 2.6373Q1.00218 3.03801 1.00003 3.48198Q0.997866 3.92742 1.15262 4.32837Q1.30921 4.73409 1.60378 5.02866Q2.22505 5.64992 3.08669 5.66146Q3.93265 5.67279 4.51884 5.08664Q4.53589 5.06959 4.55374 5.05338L8.74965 1.24406C9.15856 0.872829 9.79099 0.903371 10.1622 1.31227C10.5335 1.72118 10.5029 2.35361 10.094 2.72484L5.91471 6.51908Q5.33957 7.08705 4.58902 7.38296Q3.85603 7.67194 3.05991 7.66128Q2.26771 7.65067 1.53376 7.34488Q0.775752 7.02905 0.189568 6.44287Q-0.404247 5.84905 -0.713226 5.04852Q-1.00394 4.2953 -0.999948 3.47227Q-0.99598 2.65476 -0.702119 1.90634Q-0.392301 1.11728 0.202014 0.523219L0.202024 0.52321Q1.05306 -0.298626 1.46154 -0.707107Z"
    //       fillRule="evenodd"
    //       transform="matrix(1 0 0 1 8.77246 23.357)"
    //       fill="rgb(255, 255, 255)"
    //     />
    //     <path
    //       d="M1.57503 -0.707062C1.18454 -1.09761 0.551367 -1.09765 0.160821 -0.707152Q-0.461986 -0.0844242 -0.760985 0.741751Q-1.04826 1.53552 -0.990686 2.38686Q-0.941021 3.12192 -0.638346 3.79584Q-0.325778 4.49178 0.218788 5.03635C0.609309 5.42687 1.24248 5.42687 1.633 5.03635C2.02352 4.64583 2.02352 4.01266 1.633 3.62214Q1.05852 3.04766 1.00476 2.25203Q0.975579 1.82044 1.11964 1.42236Q1.26708 1.01498 1.57494 0.707152C1.96549 0.316656 1.96553 -0.316516 1.57503 -0.707062Z"
    //       fillRule="evenodd"
    //       transform="matrix(1 0 0 1 14.2374 18.6875)"
    //       fill="rgb(255, 255, 255)"
    //     />
    //     <path
    //       d="M-0.707107 0.707107C-1.09763 0.316586 -1.09763 -0.316586 -0.707107 -0.707107C-0.316586 -1.09763 0.316586 -1.09763 0.707107 -0.707107Q1.29329 -0.120924 1.60912 0.637089Q1.91493 1.37105 1.92555 2.16325Q1.93622 2.9594 1.64723 3.69239Q1.34658 4.45493 0.765094 5.03638C0.37456 5.42688 -0.258612 5.42686 -0.649119 5.03633C-1.03963 4.64579 -1.0396 4.01262 -0.64907 3.62211Q-0.0629297 3.03601 -0.0742691 2.19006Q-0.0858192 1.32839 -0.707107 0.707107Z"
    //       fillRule="evenodd"
    //       transform="matrix(1 0 0 1 18.136 21.0123)"
    //       fill="rgb(255, 255, 255)"
    //     />
    //   </g>
    // </svg>

    // <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    //   <rect x="6.5" y="6.5" width="9" height="13" rx="1.5" stroke="#000000" />
    //   <path
    //     d="M8.5 6C8.5 5.17157 9.17157 4.5 10 4.5H16C16.8284 4.5 17.5 5.17157 17.5 6V16C17.5 16.8284 16.8284 17.5 16 17.5"
    //     stroke="#000000"
    //   />
    // </svg>
  );
};

export default CopyIcon;
